// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerLink":"Footer_footerLink__emsFw"};